var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('select',{staticClass:"vue-select",class:_vm.id,attrs:{"multiple":!!_vm.multiple}})])
}
var staticRenderFns = []

export { render, staticRenderFns }